export const stylingForBanner = {
  gray: {
    iconColor: "cw-fill-gray-500",
    textColor: "cw-text-gray-500",
    backgroundColor: "cw-bg-[#EFF2F5]",
  },
  blue: {
    iconColor: "cw-fill-white",
    textColor: "cw-text-white",
    backgroundColor: "cw-bg-[#23A7BC]",
  },
  red: {
    iconColor: "cw-fill-white",
    textColor: "cw-text-white",
    backgroundColor: "cw-bg-[#CF7A58]",
  },
};
